import React, {Component} from 'react';
import './SocialLoginComponent.less';
import GoogleAuthComponent from '../GoogleAuthComponent/GoogleAuthComponent';
import FacebookAuthComponent from '../FacebookAuthComponent/FacebookAuthComponent';
import ExpediaAuthComponent from '../ExpediaAuthComponent/ExpediaAuthComponent';

class SocialLoginComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            emailAddress: this.props.emailAddress,
            loggedIn: false,
            error: '',
            googleToken: null,
            facebookToken: null
        };
        this.displayExpediaAuthComponent = this.displayExpediaAuthComponent.bind(this);
    }

    displayExpediaAuthComponent() {
        if (this.props.expediaIconDisplayed === true) {
            return (
                <div className="SocialLoginIcons__icon">
                    <ExpediaAuthComponent
                        actionLocation={this.props.actionLocation}
                        enableLoading={this.props.enableLoading}
                        disableLoading={this.props.disableLoading}
                        lingua={this.props.lingua}
                        handleError={this.props.handleError}
                        onClose={this.props.onClose}
                        handleLoginSuccess={this.props.handleLoginSuccess}
                        updatePage={this.props.updatePage}
                        setAuthJson={this.props.setAuthJson}
                        performBulkPageUpdate={this.props.performBulkPageUpdate}
                        site={this.props.site}
                        useNewEndpoints={this.props.useNewEndpoints}
                        emailAddress={this.state.emailAddress}
                        expediaIconDisplayed={this.props.expediaIconDisplayed}
                    />
                </div>
            );
        }
        return (
            <div/>
        );
    }

    render() {
        return (
            <div>
                <label className="SocialLoginComponent text-center"> {this.props.lingua.read('lex.social.or.text')} <span className="sr-only">{'SocialLoginComponent'}</span></label>
                <div className="SocialLoginIcons">
                    {this.displayExpediaAuthComponent()}
                    <div className="SocialLoginIcons__icon">
                        <GoogleAuthComponent
                            actionLocation={this.props.actionLocation}
                            enableLoading={this.props.enableLoading}
                            disableLoading={this.props.disableLoading}
                            lingua={this.props.lingua}
                            handleError={this.props.handleError}
                            onClose={this.props.onClose}
                            handleLoginSuccess={this.props.handleLoginSuccess}
                            updatePage={this.props.updatePage}
                            setAuthJson={this.props.setAuthJson}
                            performBulkPageUpdate={this.props.performBulkPageUpdate}
                            site={this.props.site}
                            useNewEndpoints={this.props.useNewEndpoints}
                            emailAddress={this.state.emailAddress}
                            expediaIconDisplayed={this.props.expediaIconDisplayed}
                        />
                    </div>
                    <div className="SocialLoginIcons__icon">
                        <FacebookAuthComponent
                            actionLocation={this.props.actionLocation}
                            enableLoading={this.props.enableLoading}
                            disableLoading={this.props.disableLoading}
                            lingua={this.props.lingua}
                            handleError={this.props.handleError}
                            locale={this.props.locale}
                            onClose={this.props.onClose}
                            handleLoginSuccess={this.props.handleLoginSuccess}
                            updatePage={this.props.updatePage}
                            setAuthJson={this.props.setAuthJson}
                            performBulkPageUpdate={this.props.performBulkPageUpdate}
                            site={this.props.site}
                            useNewEndpoints={this.props.useNewEndpoints}
                            emailAddress={this.state.emailAddress}
                            expediaIconDisplayed={this.props.expediaIconDisplayed}
                        />
                    </div>
                    </div>
                </div>

        );
    }
}

export default SocialLoginComponent;
